export const canUseApplePay = () => {
  if (
    window &&
    window.ApplePaySession &&
    typeof window.ApplePaySession.canMakePayments === 'function'
  ) {
    const canMakePayments = window.ApplePaySession.canMakePayments();
    return canMakePayments;
  }
  return false;
};
